function getParams(){
    try {
        const urlParams = new URLSearchParams(window.location.search.substring(1));
        return Object.fromEntries(urlParams);
    } catch(err){
        return {}
    }
}

export default getParams;